// ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useAuth } from "../components/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <Box sx={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress size={26} sx={{ color: "#1E2A38" }} />
      </Box>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
